import styled from "styled-components";

import { Stack } from "@similarweb/ui-components/foundations";

export const StyledFilterPanelPositioner = styled(Stack)`
    position: relative;
    height: 100%;

    > aside {
        flex: 1;
        min-height: 0;
        height: auto;
    }
`;
